module.exports = __webpack_public_path__ + "static/media/burger-bohemian-carousel.6022e0a6.jpg";